import { SearchInsights } from '@sly/core/src/types';

const ALLOWED_TOC = ['assisted-living', 'memory-care', 'independent-living'];

export function getIsAllowed({
  toc,
  city,
}: {
  toc: string;
  city: string | null;
}) {
  if (!city) {
    return false;
  }
  if (!ALLOWED_TOC.includes(toc)) {
    return false;
  }

  return true;
}

export function getIsValidSearchInsights(
  searchInsights: SearchInsights | SearchInsights[] | null
) {
  if (
    !searchInsights ||
    Array.isArray(searchInsights) ||
    searchInsights?.nearest
  ) {
    return false;
  }

  return true;
}
